export const htmlId: string = 'cart-basket-table';